
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa930373bd789ca3f86c70494b0c674e6en from './en.yaml'
            i18n.addResourceBundle('en', 'a930373bd789ca3f86c70494b0c674e6', flattenObject(nsa930373bd789ca3f86c70494b0c674e6en), true, true);
        
        export default 'a930373bd789ca3f86c70494b0c674e6';
    